/**
 * Wingit Responsive Breakpoint System
 *
 * Single source of truth for JavaScript viewport breakpoints.
 * Use with matchMedia() or the useMediaQuery() hook for responsive logic.
 *
 * Breakpoints:
 * - Phone: below 600px
 * - Tablet: 600px–1023px
 * - Desktop: 1024px and above
 *
 * For CSS media queries, use literal pixel values directly (not CSS custom properties).
 */

/**
 * Breakpoint values in pixels
 */
export const BREAKPOINTS = {
  phone: 600,
  tablet: 1024,
};

/**
 * CSS media query strings for use with matchMedia() and useMediaQuery() hook.
 * These produce literal queries like "(min-width: 600px)" that work correctly.
 */
export const MEDIA_QUERIES = {
  // Phone: below 600px
  phone: `(max-width: ${BREAKPOINTS.phone - 1}px)`,

  // Tablet: 600px–1023px
  tabletOnly: `(min-width: ${BREAKPOINTS.phone}px) and (max-width: ${BREAKPOINTS.tablet - 1}px)`,
  tabletAndUp: `(min-width: ${BREAKPOINTS.phone}px)`,

  // Desktop: 1024px and above
  desktopAndUp: `(min-width: ${BREAKPOINTS.tablet}px)`,
};

/**
 * Device detection helpers using matchMedia API
 */
export const isAtLeastTablet = () => window.matchMedia(MEDIA_QUERIES.tabletAndUp).matches;
export const isAtLeastDesktop = () => window.matchMedia(MEDIA_QUERIES.desktopAndUp).matches;
export const isPhoneOnly = () => window.matchMedia(MEDIA_QUERIES.phone).matches;
